/**
 * Created by idea on 03/07/2017.
 */
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {BreadcrumbComponent} from './breadcrumb.component';

@NgModule({
    declarations: [BreadcrumbComponent],
    imports     : [BrowserModule, RouterModule],
    exports     : [BreadcrumbComponent],
})

export class BreadcrumbModule {}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/breadcrumb/breadcrumb.module.ts